import React from 'react';
import styled from 'styled-components';
import Card from './Card';
import data from './data';
import { Header, HeadingText, SubHeadingText, Wrapper } from '../common';
import breakpointsMinWidth from '../../../../../../styling/breakpointsMinWidth';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media ${breakpointsMinWidth.tabletLg} {
    gap: 24px;
  }
`;

const GenerateCLPopup = ({
  setWizardAnimation,
  handleClosePopup,
  setModal,
  onClose,
}) => {
  const { heading, subHeading, sampleCoverLetter, jobSpecificCoverLetter } =
    data;
  return (
    <Wrapper>
      <Header>
        <HeadingText>{heading}</HeadingText>
        <SubHeadingText>{subHeading}</SubHeadingText>
      </Header>
      <Content>
        <Card
          type="sampleCoverLetter"
          heading={sampleCoverLetter.headingText}
          subHeading={sampleCoverLetter.subHeadingText}
          Image={sampleCoverLetter.image}
          setWizardAnimation={setWizardAnimation}
          handleClosePopup={handleClosePopup}
          onClose={onClose}
        />
        <Card
          type="jobSpecific"
          heading={jobSpecificCoverLetter.headingText}
          subHeading={jobSpecificCoverLetter.subHeadingText}
          Image={jobSpecificCoverLetter.image}
          setModal={setModal}
        />
      </Content>
    </Wrapper>
  );
};

export default GenerateCLPopup;
